import { CouponIcon } from "@xola/icons";
import { Badge } from "@xola/ui-kit";
import React from "react";
import { Audit, Purchase, PurchaseItem } from "types";
import { Currency } from "../../../Common/Currency";
import { TimelineItem } from "../TimelineItem";

interface RemoveCouponTimelineItemProps {
    purchase: Purchase;
    item: PurchaseItem;
    audit: Audit;
    showDate?: boolean;
}

export const RemoveCouponTimelineItem = ({
    purchase,
    item,
    audit,
    showDate = false,
}: RemoveCouponTimelineItemProps) => {
    const matchedLineItem = RemoveCouponTimelineItem.supportsAudit(purchase, item, audit);
    if (!matchedLineItem) {
        return null;
    }

    const removedCode = matchedLineItem.couponCode?.old?.code ?? matchedLineItem.name?.old;

    return (
        <TimelineItem
            title="Removed Coupon"
            audit={matchedLineItem}
            icon={<CouponIcon />}
            color="danger"
            showDate={showDate}
            purchase={purchase}
        >
            <div className="space-x-2 text-gray-darker">
                <Currency shouldRemoveTrailingZeroes={false}>{Math.abs(matchedLineItem?.amount?.old)}</Currency>
                <Badge color="secondary" icon={<CouponIcon />} className="no-translate">
                    {removedCode}
                </Badge>
            </div>
        </TimelineItem>
    );
};

RemoveCouponTimelineItem.supportsAudit = (_purchase: Purchase, _item: PurchaseItem, _audit: Audit) => {
    let auditItem;
    if (Array.isArray(_audit.data.items)) {
        auditItem = _audit.data?.items?.find((item_: PurchaseItem) => item_.id === _item?.id);
    } else {
        for (const itemIndex in _audit.data.items) {
            if (_audit.data.items[itemIndex].id === _item.id) {
                auditItem = _audit.data.items[itemIndex];
            }
        }
    }

    if (!auditItem) {
        return null;
    }

    const lineItems = Object.values(auditItem?.lineItems ?? {});
    const matchedItem: any = lineItems.find(
        (lineItem: any) => !!(lineItem.coupon?.new === null && lineItem.coupon?.old),
    );

    if (!matchedItem) {
        return null;
    }

    return { ...matchedItem, createdAt: _audit.createdAt, createdBy: _audit.createdBy };
};
